import { Injectable, NgZone } from '@angular/core';
import {
  HttpClient, HttpParams, HttpHeaders
} from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { ServiceBase } from './base.service';
import { AuthService } from './auth.service';
import { Data } from '../providers/data';
import { Observable } from 'rxjs';

@Injectable()
export class UserService {
  constructor(
    private http: HttpClient,
    private serviceBase: ServiceBase,
    private authService: AuthService,
    private data: Data,


  ) {}

  urlService = this.serviceBase.getUrlApi('v1/user');

  obtenerPerfiles(): Observable<any>{
    return this.http.get<any>(`${this.urlService}profiles`)
    .pipe(
      map((response) => response ),
      catchError(this.serviceBase.handleError)
    );
  }


  obtenerUsuarios(): Observable<any>{
    return this.http.get<any>(`${this.urlService}`)
    .pipe(
      map((response) => response ),
      catchError(this.serviceBase.handleError)
    );
  }



  create(req): Observable<any>{

    const url = `${this.urlService}`;
    const body = {
      email: req.email,
      firstName: req.nombre,
      lastName: req.apellido,
      delegationId: req.delegacionId,
      profileId: req.perfilId,
    };
    return this.http.post<any>(url, body,
      this.serviceBase.postCommonHeaders()
    ).pipe(
      map((response) => response),
      catchError(this.serviceBase.handleError)
    );
  }

  update(req): Observable<any>{

    const url = `${this.urlService}`;
    const body = {
      userId: req.id,
      firstName: req.nombre,
      lastName: req.apellido,
      email: req.email,
      profileId: req.perfilId,
    };
    return this.http.put<any>(url, body,
      this.serviceBase.postCommonHeaders()
    ).pipe(
      map((response) => response),
      catchError(this.serviceBase.handleError)
    );
  }

  delete(userId): Observable<any>{
    return this.http.delete<any>( this.urlService + userId)
    .pipe(
        map((response) => (response)),
        catchError(this.serviceBase.handleError)
    );
  }


}
